import { IServiceEvent } from "../types/IServiceEvent";
import { IService } from "../types/IService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DeleteServiceStatus } from "../services/DeleteServiceStatus";
import { RetryService } from "../services/RetryService";
import { IEventStatus } from "../types/IEventStatus";
import { useState } from "react";
import { PostEventStatus } from "../services/PostEventStatus";
import { IEventType } from "../types/IEventType";

/**
 * Service card component
 */
export const ServiceActionModal = (props: {
    service: IService;
    event: IServiceEvent;
    visible: boolean;
    onHide: () => void;
}) => {
    const [loading, setLoading] = useState<boolean>(false);

    async function deleteClick() {
        setLoading(true);
        const result = await DeleteServiceStatus(
            props.service.parentId,
            props.event.eventId
        );
        console.info(result);
        setLoading(false);
        props.onHide();
    }

    async function retryClick() {
        setLoading(true);
        const result = await RetryService(
            props.service.parentId,
            props.event.eventId
        );
        console.info(result);
        setLoading(false);
        props.onHide();
    }

    const resolveClick = async () => {
        setLoading(true);
        const result = await PostEventStatus(
            props.event,
            IEventType.SUCCESS,
            "Service marked as resolved",
            IEventStatus.RESOLVED
        );
        console.info(result);
        setLoading(false);
        props.onHide();
    };

    const footer = (
        <div>
            <Button
                className="p-button-rounded p-button-primary"
                label="Resolve"
                icon="pi pi-check"
                disabled={props.event.status !== IEventStatus.FAILED}
                onClick={resolveClick}
                loading={loading}
            />
            <Button
                className="p-button-rounded p-button-primary"
                label="Retry"
                icon="pi pi-sync"
                disabled={props.event.status !== IEventStatus.FAILED}
                onClick={retryClick}
                loading={loading}
            />
            <Button
                className="p-button-rounded p-button-secondary p-button-danger"
                label="Delete"
                icon="pi pi-trash"
                onClick={deleteClick}
                loading={loading}
            />
        </div>
    );

    return (
        <Dialog
            header={<h2>{props.service.name}</h2>}
            footer={footer}
            style={{ width: "50vh" }}
            visible={props.visible}
            modal
            onHide={props.onHide}
        >
            <div>
                <small>Event Key: {props.event.eventId}</small>

                {Number(props.event.retry) > 0 ? (
                    <div>
                        <br></br>
                        <small style={{ color: "red" }}>
                            Retries: {props.event.retry}
                        </small>
                    </div>
                ) : null}

                {props.event.status !== IEventStatus.FAILED ? (
                    <p
                        style={{ fontSize: 13, color: "orange" }}
                        className="mt-3"
                    >
                        This event is still <b>new/pending </b>and will be going
                        through the event retry system. You will be unable to
                        manually retry/resolve this event until it is finished.
                        Please take care when deleting the event.
                    </p>
                ) : null}

                <h4>Error:</h4>

                <div className="serviceCode mt-2">
                    <code className="">{props.event.message}</code>
                </div>

                <h4>Input Data:</h4>

                <div className="serviceCode mt-2">
                    <code className="">{props.event.data}</code>
                </div>
            </div>
        </Dialog>
    );
};
